export const PaymentTypes = {
    DEPTS: 1,
    CUSTOM: 2
}

import general from '@/wl-core/helpers/general'
export class CartItem {
    constructor({name, quantity, currency, value, description, sku, cart_id, payment_type, partner_id, branch_id}) {
        this.name = this.setName(name);
        this.quantity = quantity;
        this.description = this.setDescription(description);
        this.unit_amount = {currency_code: currency, value: general.round(value)}
        this.cart_id = cart_id
        this.payment_type = payment_type
        this.Partner_ID = partner_id ? partner_id : null;
        this.Branch_ID = branch_id ? branch_id : null;
        if (sku) this.sku = this.setSku(sku);
    }

    setName(name) {
        if ([...name].length <= 127) {
            return name
        } else {
            return name.substring(0, 127)
        }
    }


    setDescription(description) {
        if ([...description].length <= 127) {
            return description
        } else {
            return description.substring(0, 127)
        }
    }

    setSku(sku) {
        if ([...sku].length <= 127) {
            return sku
        } else {
            return sku.substring(0, 127)
        }
    }

    getValue() {
        return this.unit_amount.value * this.quantity;
    }

}
